import _ from 'lodash';
import { dropdownMap, multiMap, multiDropdownMap } from '../constants/maps';
import { HELPER_KEYWORDS_SUPPORT_FIELDS, HELPER_CORP_SUPPORT_FIELDS, HELPER_CLASSIFICATION_SUPPORT_FIELDS, FIELD_IPC, FIELD_MIPC, FIELD_IPC_CPC, FIELD_CPC, FIELD_CPC_ALL, FIELD_MCPC, FIELDS_DATE, FIELDS_NUMBER, FIELDS_SELECT, FIELDS_MULTI_CHECK, FIELDS_MULTI_DROPDOWN, FIELDS_WORKSPACE, FIELDS_COMBINE, FIELDS_CHECK_AND_SEARCH, FIELD_LEGAL_STATUS, FIELD_LEGAL_EVENT, FIELD_SIMPLE_LEGAL_STATUS, FIELD_EP_LEGAL_STATUS, FIELD_EP_SIMPLE_LEGAL_STATUS, FIELD_AWARD_COMBINE, FIELD_ENTRY_COUNTRY_STATUS, FIELD_ENTRY_COUNTRY_LEGAL_STATUS, } from '../constants/fields';
import { CONTROL_RANGE_DATE, CONTROL_RANGE_NUMBER, CONTROL_INPUT, CONTROL_SELECT, CONTROL_MULTI_CHECK, CONTROL_MULTI_DROPDOWN, CONTROL_WORKSPACE_FOLDER_SELECT, CONTROL_COMBINE_FIELD_SELECT, CONTROL_CUSTOM_FIELD_SELECT, CONTROL_CASCADING_FIELD_SELECT, CONTROL_MULTI_CHECK_AND_SEARCH, } from '../controls/constants';
import { getLegalConfig } from '../../components/legal-tag/legal-config.js';
const { includes, map, uniqBy, get, filter } = _;
import { SUPPORT_LEVEL_LEGAL_STATUS_CODE } from '../../constants';
//来自后端配置的三个字段
export const LEGAL_CONFIG_FIELDS = [
    FIELD_LEGAL_STATUS,
    FIELD_LEGAL_EVENT,
    FIELD_SIMPLE_LEGAL_STATUS,
    FIELD_EP_LEGAL_STATUS,
    FIELD_EP_SIMPLE_LEGAL_STATUS,
    FIELD_ENTRY_COUNTRY_STATUS,
    FIELD_ENTRY_COUNTRY_LEGAL_STATUS,
];
export const getOptions = (name, type) => {
    let dropdownMapData = dropdownMap[name];
    if (type === 'patent' || type === 'legal-patent') {
        if (name === 'RIDTP') {
            dropdownMapData = uniqBy([...dropdownMap['RIDTP'], ...dropdownMap['RIDTP_CN'], ...dropdownMap['RIDTP_EP']], item => item.label);
        }
    }
    return (dropdownMapData || multiMap[name] || multiDropdownMap[name] || []).map(({ label, ...rest }) => {
        return {
            i18n: label,
            ...rest,
        };
    });
};
export const getLegalStatusOptions = (name, lang) => {
    const legalStatusData = getLegalConfig();
    let currentFieldList = filter(legalStatusData, l => l.codeType === name);
    if (name === 'EPDS_LS') {
        currentFieldList = filter(legalStatusData, l => l.codeType === 'LEGAL_STATUS' && l.isEpStatus);
    }
    else if (name === 'EPDS_SLS') {
        currentFieldList = filter(legalStatusData, l => l.codeType === 'SIMPLE_LEGAL_STATUS' && l.isEpStatus);
    }
    else if (name === 'ENTRY_COUNTRY_LS') {
        currentFieldList = filter(legalStatusData, l => l.codeType === 'LEGAL_STATUS' && l.isEntryCountryLS);
    }
    else if (name === 'ENTRY_COUNTRY_SLS') {
        currentFieldList = filter(legalStatusData, l => l.codeType === 'SIMPLE_LEGAL_STATUS' && l.isEntryCountrySlS);
    }
    let legalStatusOptions = [];
    legalStatusOptions = map(currentFieldList, c => {
        const label = name === 'EPDS_LS' || name === 'EPDS_SLS' ? get(c, `epLabel.${lang}`, '') : get(c, `label.${lang}`, '');
        const value = get(c, 'code');
        const option = { label: label || value, value };
        if (SUPPORT_LEVEL_LEGAL_STATUS_CODE.includes(value)) {
            const relatedCode = [];
            c.relatedCode.forEach(code => {
                const item = _.find(legalStatusData, { code, codeType: 'LEGAL_STATUS' });
                if (item) {
                    relatedCode.push({
                        label: get(item, `label.${lang}`, ''),
                        value: code,
                    });
                }
            });
            option.relatedCode = relatedCode;
        }
        return option;
    });
    return legalStatusOptions;
};
export const getMultiDropdownOptionValue = name => {
    if (name && multiDropdownMap[name]) {
        const valueArr = map(multiDropdownMap[name], item => item.value);
        return valueArr.join(' OR ');
    }
    return '';
};
export const getMultiOptionValue = name => {
    if (name && multiMap[name]) {
        const valueArr = map(multiMap[name], item => item.value);
        return valueArr.join(' OR ');
    }
    return '';
};
export const transformSubType = field => {
    let helperField = field;
    switch (field) {
        case FIELD_MCPC:
        case FIELD_CPC_ALL:
            helperField = FIELD_CPC;
            break;
        case FIELD_MIPC:
        case FIELD_IPC_CPC:
            helperField = FIELD_IPC;
            break;
        default:
            break;
    }
    return helperField;
};
export const getHelperInfo = field => {
    field = field.toUpperCase();
    if (includes(HELPER_CLASSIFICATION_SUPPORT_FIELDS, field)) {
        let helperField = transformSubType(field);
        return {
            i18n: `advanceSearchForm.helper.${helperField.toLowerCase()}`,
            type: 'classification',
            field,
            helperField
        };
    }
    if (includes(HELPER_KEYWORDS_SUPPORT_FIELDS, field)) {
        return {
            i18n: 'advanceSearchForm.helper.keywords',
            type: 'keyword',
            field,
        };
    }
    if (includes(HELPER_CORP_SUPPORT_FIELDS, field)) {
        return {
            i18n: 'advanceSearchForm.helper.corporate',
            type: 'corporate',
            field,
        };
    }
    return null;
};
export const getContorlType = (value = '') => {
    const field = value.toUpperCase();
    if (includes(FIELDS_DATE, field)) {
        return CONTROL_RANGE_DATE;
    }
    if (includes(FIELDS_NUMBER, field)) {
        return CONTROL_RANGE_NUMBER;
    }
    if (includes(FIELDS_SELECT, field)) {
        return CONTROL_SELECT;
    }
    if (includes(FIELDS_MULTI_CHECK, field)) {
        return CONTROL_MULTI_CHECK;
    }
    if (includes(FIELDS_MULTI_DROPDOWN, field)) {
        return CONTROL_MULTI_DROPDOWN;
    }
    if (includes(FIELDS_WORKSPACE, field)) {
        return CONTROL_WORKSPACE_FOLDER_SELECT;
    }
    if (includes(FIELDS_COMBINE, field)) {
        return CONTROL_COMBINE_FIELD_SELECT;
    }
    if (includes(FIELDS_CHECK_AND_SEARCH, field)) {
        return CONTROL_MULTI_CHECK_AND_SEARCH;
    }
    if (field === FIELD_AWARD_COMBINE) {
        return CONTROL_CASCADING_FIELD_SELECT;
    }
    if (field.startsWith('CCF_')) {
        return CONTROL_CUSTOM_FIELD_SELECT;
    }
    return CONTROL_INPUT;
};
